export default "__VITE_ASSET__fj7a$e0v__"